<template>
  <div class="w-full relative h-6 z-0 pb-4">
    <!-- Style Valtra -->
    <template v-if="brand === 'valtra'">
      <!-- Banner Valtra -->
      <div class="absolute top-0 left-0 w-full pt-4 px-8 z-0">
        <img :src="bannerUrl" alt="Valtra Banner" class="w-full z-0">
      </div>
    </template>

    <!-- Style par défaut -->
    <template v-else>
      <div
        v-if="props.hasImage"
        class="w-full flex items-center banner-container"
        :style="{
          justifyContent: 'flex-start',
          paddingLeft: '3rem',
          height: '64px',
        }"
      >
        <img :src="logoUrl" :alt="brand" class="h-8">
      </div>
      <div
        v-else
        class="w-full bg-gray-100 flex banner-header-default"
        :style="{
          justifyContent: 'flex-end',
          paddingRight: '1rem',
          alignItems: 'center',
          height: '64px',
        }"
      >
        <img :src="logoUrl" :alt="brand" class="h-8">
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from "@vue/runtime-core";

const DEFAULT_BRAND = "agco" as const;
type BrandType = "agco" | "valtra";

interface Props {
  hasImage?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  hasImage: false,
});

const brand = (localStorage.getItem("brand") as BrandType) || DEFAULT_BRAND;
const logoUrl = computed(
  () => `${import.meta.env.VITE_API_URL}/upl/assets/logo-${brand}.svg`
);
const bannerUrl = computed(
  () =>
    `${import.meta.env.VITE_API_URL}/upl/assets/banner-valtra-full-width.svg`
);
</script>

<script lang="ts">
export default {
  name: "BanderoleHeader",
};
</script>

<style scoped>
.banner-container {
  background-color: rgb(243 244 246);
  clip-path: polygon(0 0, 100% 0, 95% 100%, 0 100%);
}
</style>
